import $ from "jquery";
import imagesLoaded from "imagesloaded";
import "@splidejs/splide/css";
import Splide from "@splidejs/splide";

import LangSelector from "./components/lang-selector";
import SiteHeader from "./components/site-header";
import HomeSlider from "./components/home-slider";
import ReviewsSlider from "./components/reviews-slider";
import PartnersSlider from "./components/partners-slider";
import PortalPageSlider from "./components/portal-page-slider";
import HandheldMenu from "./components/handheld-menu";
import CookiesConsent from "./components/cookies-consent";
import DropdownMenu from "./components/dropdown-menu";
import Gallery from "./components/gallery";
import NewsletterForm from "./components/newsletter-form";
import ScrollInView from "./components/scroll-in-view";

import DeviceManager from "./utils/device-manager";

import { AccordionDef } from "./components/accordion";
import { filterIncident } from "./components/filterIncident";

// (function ($) {
// window.$ = $;

$(function () {
  const bootstrapApp = () => {
    const $html = $("html");

    // Touch device detection
    if (DeviceManager.isHandheld()) {
      $html.addClass("touch");

      if (DeviceManager.isIos()) {
        $html.addClass("ios");
      }
    } else {
      $html.addClass("no-touch");
    }

    // IE detection
    if (DeviceManager.isIe11()) {
      $html.addClass("ie11");
    } else if (DeviceManager.isEdge()) {
      $html.addClass("edge");
    }
  };

  const instanciateComponents = () => {
    // General components
    const langSelector = new LangSelector($(".language-selector"));
    const siteHeader = new SiteHeader($(".site-header"), 20);

    // Home slider component
    const $homesSliders = $(".homepage-slider");
    if ($homesSliders.length) {
      $homesSliders.each(function (index, el) {
        const homeSlider = new HomeSlider($(el));
      });
    }

    // News slider component
    const $newsSliders = $(".news-list--slider");
    if ($newsSliders.length) {
      $newsSliders.each(function (index, el) {
        const newsSlider = new NewsSlider($(el));
      });
    }

    // Partners slider component
    const $partnersSliders = $(".partners-slider");
    if ($partnersSliders.length) {
      $partnersSliders.each(function (index, el) {
        const partnerSlider = new PartnersSlider($(el));
      });
    }

    // Reviews slider component
    const $reviewsSlider = $(".reviews-slider");
    if ($reviewsSlider.length) {
      $reviewsSlider.each(function (index, el) {
        const reviewsSlider = new ReviewsSlider($(el));
      });
    }

    // BU Product slider component
    const $buProductSlider = $(".bu-products-slider");
    if ($buProductSlider.length) {
      $buProductSlider.each(function (index, el) {
        const buProductSlider = new BUProductSlider($(el));
      });
    }

    // Portal page slider component
    const $portalPageSliders = $(".portal-page__header-slider");
    if ($portalPageSliders.length) {
      $portalPageSliders.each(function (index, el) {
        const portalPageSlider = new PortalPageSlider($(el));
      });
    }

    // Newsletter form component
    const $newsletterFormElements = $(
      ".footer-block.footer-block--newsletter-style"
    );
    if ($newsletterFormElements.length) {
      $newsletterFormElements.each(function (index, el) {
        const newsletterForm = new NewsletterForm(el);
      });
    }

    // Cookie consent
    if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
      // Tarteaucitron cookie settings
      let tarteaucitronLang = "fr";

      const cookiesConsent = new CookiesConsent(tarteaucitronLang);
    }

    // Scroll in view component
    const $scrollInViewElements = $(".scroll-in-view");
    if ($scrollInViewElements.length) {
      $scrollInViewElements.imagesLoaded(function () {
        const scrollInView = new ScrollInView($scrollInViewElements);
      });
    }
  };

  bootstrapApp();
  instanciateComponents();
});

// })(jQuery);

const menuBtn = document.querySelector(".menu-btn");
const subMenuBtn = document.querySelectorAll(
  '.menu-item-has-children > a[href="#"]'
);
const lignesFilter = document.querySelector("#ligne");
const timeFilter = document.querySelector("#infos");
const submitFilter = document.querySelector("#submitFilter");
const lignes = document.querySelectorAll(".ligne");
const incidents = document.querySelectorAll(".incidents > .incident");

if (lignesFilter && timeFilter && submitFilter && incidents) {
  submitFilter.addEventListener("click", () => {
    filterIncident(lignesFilter.value, timeFilter.value, incidents);
  });
}

if (lignes) {
  lignes.forEach((ligne) => {
    const incidentButton = ligne.querySelector(".incident-img");
    incidentButton?.addEventListener("click", () => {
      const incident = ligne.nextElementSibling;
      incident?.classList.toggle("active");
    });
  });
}

if (menuBtn) {
  menuBtn.addEventListener("click", () => {
    const menu = document.getElementById("main-menu");
    menu?.classList.toggle("active");
  });
}

if (subMenuBtn) {
  subMenuBtn.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();
      const parent = item.parentElement;
      parent?.classList.toggle("active");
    });
  });
}

const details = document.querySelectorAll("details");

if (details) {
  details.forEach((el) => {
    new AccordionDef(el);
  });
}

const splideContainer = document.querySelector(".splide");
if (splideContainer) {
  new Splide(splideContainer, {
    type: "fade",
    perPage: 1,
    autoplay: true,
    interval: 5000,
    pauseOnHover: true,
  }).mount();
}
